{
  "home": {
    "title": "Ask about {{name}}",
    "titleNoBaby": "Ask anything",
    "knowsLog": "Knows {{name}}'s log",
    "knowsProfile": "Knows {{name}}'s age",
    "lead": "Sleep, feeding, growing up, and how you're doing. Any hour.",
    "plateAlt": "a felt lamb",
    "tryAsking": "Try asking",
    "recent": "Recent",
    "untitled": "New chat",
    "yesterday": "Yesterday",
    "loadFailed": "Couldn't load your chats.",
    "left_one": "{{count}} message left",
    "left_other": "{{count}} messages left",
    "renews": "more on {{date}}",
    "yourBaby": "your baby",
    "seeAll": "See all",
    "seeAllCount": "All {{count}}",
    "history": "Past chats"
  },
  "suggest": {
    "newborn": [
      "How much should {{name}} sleep at {{age}}?",
      "How do I know {{name}} is getting enough milk?",
      "Why does {{name}} only sleep when held?",
      "How do I get through the nights on so little sleep?"
    ],
    "infant": [
      "How long should {{name}} be awake between naps?",
      "Is this the 4-month sleep regression?",
      "How do I start a calm bedtime routine?",
      "When can we start solid foods?"
    ],
    "older": [
      "How many naps does {{name}} need at {{age}}?",
      "{{name}} wakes up at night again. What can we try?",
      "Which first finger foods are safe?",
      "Is separation anxiety normal at this age?"
    ],
    "toddler": [
      "When do toddlers move to one nap?",
      "How do I handle bedtime battles?",
      "How much milk should a toddler drink?",
      "How many words should {{name}} say by now?"
    ],
    "preschool": [
      "How do I stay calm through tantrums?",
      "Is {{name}} ready to drop the nap?",
      "When should we move to a big bed?",
      "How do I know {{name}} is ready for potty training?"
    ]
  },
  "suggestTag": {
    "newborn": [
      "Sleep",
      "Feeding",
      "Sleep",
      "You"
    ],
    "infant": [
      "Sleep",
      "Sleep",
      "Bedtime",
      "Feeding"
    ],
    "older": [
      "Sleep",
      "Sleep",
      "Feeding",
      "Growing"
    ],
    "toddler": [
      "Sleep",
      "Bedtime",
      "Feeding",
      "Growing"
    ],
    "preschool": [
      "You",
      "Sleep",
      "Sleep",
      "Growing"
    ]
  },
  "fromLog": {
    "sleep": "How has {{name}} slept the last 3 days?",
    "feeds": "Are {{name}}'s feeds on track this week?",
    "tag": "From your log"
  },
  "thread": {
    "back": "Chats",
    "newChat": "New chat",
    "loading": "Opening your chat…",
    "loadFailed": "Couldn't open this chat.",
    "notFound": "This chat was deleted.",
    "you": "You",
    "assistant": "Baby Plan",
    "about": "About {{name}} · {{age}}"
  },
  "composer": {
    "label": "Your question",
    "placeholder": "Ask a question…",
    "placeholderName": "Ask about {{name}}…",
    "placeholderMore": "Ask a follow-up…",
    "send": "Send",
    "stop": "Stop the answer",
    "tooLong": "{{count}} characters too long",
    "charsLeft": "{{count}} characters left",
    "leftToday_one": "{{count}} question left today",
    "leftToday_other": "{{count}} questions left today"
  },
  "disclaimer": "AI answers can be wrong. Not medical advice. For urgent symptoms, call your pediatrician or 911.",
  "answer": {
    "thinking": "Thinking",
    "thinkingLong": "Finishing your previous answer first…",
    "answering": "Answering…",
    "truncated": "This answer hit its length limit. Ask “go on” to hear the rest.",
    "stopped": "You stopped this answer. The full answer is saved in this chat.",
    "showFull": "Show the full answer",
    "interrupted": "The connection dropped. The answer is still being saved.",
    "reload": "Show the answer",
    "failed": "This answer didn't finish.",
    "retry": "Try again",
    "editQuestion": "Change the question",
    "codes": {
      "coach_timeout": "That took too long, so we stopped waiting. Please try again.",
      "coach_overloaded": "The assistant is very busy right now. Try again in a minute.",
      "coach_upstream_error": "The assistant had a hiccup. Please try again.",
      "answer_blocked": "I can't help with that question. Try asking it a different way.",
      "internal_error": "Something went wrong on our side. Please try again."
    }
  },
  "follow": {
    "label": "Ask next",
    "tryFirst": "What should I try first?",
    "normal": "Is this normal at {{age}}?",
    "simpler": "Explain it more simply"
  },
  "errors": {
    "coach_daily_cap": "That's a lot of questions for one day. The chat is back tomorrow.",
    "coach_busy": "Another answer is still being written. Try again in a few seconds.",
    "message_too_long": "That question is a bit long. Please shorten it.",
    "message_empty": "Type a question first.",
    "offline": "You're offline. Your question is still in the box.",
    "generic": "That didn't send. Please try again."
  },
  "unavailable": {
    "title": "Chat is resting for a moment",
    "body": "We couldn't reach the assistant just now. Your question is still in the box below. Please try again in a few minutes.",
    "retry": "Try again"
  },
  "limit": {
    "monthlyTitle": "That's this month's messages",
    "monthlyBody": "You've used your {{count}} messages for this month. More arrive on {{date}}. Need answers sooner? Add a message pack.",
    "monthlyBodyNoDate": "You've used your {{count}} messages for this month. Need answers sooner? Add a message pack.",
    "emptyTitle": "You're out of messages",
    "emptyBody": "Get {{count}} more messages to keep asking. Your chats stay here.",
    "more": "Get {{count}} more messages",
    "dailyTitle": "That's a lot of questions for one day",
    "dailyBody": "The chat takes a short break and is back tomorrow. If something is urgent, call your pediatrician or 911."
  },
  "packs": {
    "title": "Get more messages",
    "leadMonthly": "You've used this month's messages. More arrive on {{date}}. Need answers now? Add a pack, it never expires.",
    "leadMonthlyNoDate": "You've used this month's messages. Need answers now? Add a pack, it never expires.",
    "leadEmpty": "Each purchase adds {{count}} messages. Pay once, use them whenever you need.",
    "orPacks": "Or pay once for a pack of messages",
    "count_one": "{{count}} message",
    "count_other": "{{count}} messages",
    "once": "one time",
    "buyOneclick": "Buy",
    "buyCard": "Pay with card",
    "added_one": "Added! You have {{count}} message.",
    "added_other": "Added! You have {{count}} messages.",
    "loadFailed": "Packs couldn't load. Try again later."
  },
  "redFlag": {
    "title": "If this could be urgent",
    "body": "Call 911 now for trouble breathing, blue lips, if your baby is hard to wake or has a seizure. For other worrying signs, call your pediatrician right away.",
    "call": "Call 911",
    "buttons": {
      "call911": "Call 911",
      "callPoison": "Call 1-800-222-1222",
      "call988": "Call 988",
      "text988": "Text 988"
    },
    "emergency911": "Emergency? Call 911",
    "inDanger": "In danger right now? Call 911",
    "routes": {
      "call_911": {
        "title": "Call 911 now",
        "body": "If your baby is struggling to breathe, turning blue or gray, hard to wake, having a seizure or has a swollen face or lips, call 911 now."
      },
      "emergency_room": {
        "title": "Go to the emergency room now",
        "body": "This needs a doctor right away, even if your baby seems fine. If you can't get there quickly, call 911."
      },
      "poison_control": {
        "title": "Call Poison Control now",
        "body": "Experts answer free, 24/7, and will tell you exactly what to do. Call 911 if your baby is struggling to breathe, hard to wake or having a seizure."
      },
      "crisis_988": {
        "title": "You don't have to do this alone",
        "body": "Put your baby on their back in the crib, step out for a few minutes, and call or text 988 to talk to someone now."
      },
      "pediatrician_or_er": {
        "title": "Call your pediatrician now",
        "body": "A baby under 3 months with a fever or a low temperature needs a doctor right away. If you can't reach yours quickly, go to the emergency room."
      },
      "pediatrician": {
        "title": "Call your pediatrician now",
        "body": "Use the after-hours line if it's night. If you can't reach them, go to urgent care or the emergency room."
      }
    }
  },
  "deleteSheet": {
    "title": "Delete this chat?",
    "body": "The questions and answers in it are removed for good.",
    "confirm": "Delete chat",
    "cancel": "Keep it",
    "failed": "Couldn't delete the chat. Please try again."
  },
  "upsell": {
    "title": "Ask Baby Plan, any hour",
    "lead": "A calm, practical helper for the questions that come up at 3 am. Pay once for {{count}} messages, get more any time.",
    "plateAlt": "a felt lamb",
    "points": [
      "Sleep, naps, feeding and first foods",
      "Development, milestones and everyday worries",
      "Knows your baby, your log, today's plan and the Baby Plan course",
      "Room for you too: tiredness, stress, getting help"
    ],
    "examplesTitle": "Parents ask things like",
    "examples": [
      "Why is she suddenly up at 5 am?",
      "How many ounces should he drink at 4 months?",
      "Is it normal that he isn't crawling yet?"
    ],
    "price": "{{price}} {{period}}",
    "period": {
      "month": "a month",
      "year": "a year",
      "once": "one-time",
      "week": "a week"
    },
    "buyOneclick": "Get {{count}} messages · {{price}}",
    "buyCard": "Continue to payment",
    "buyNoPrice": "Get {{count}} messages",
    "oneclickHint": "Charged to the card you used for Baby Plan.",
    "cardHint": "Pay securely by card on the next step.",
    "buying": "Adding Chat…",
    "checking": "Checking your payment…",
    "checkingHint": "This can take a minute. Please don't buy again: if the payment went through, Chat opens by itself.",
    "slow": "Your payment is still being processed. Chat opens by itself as soon as it's confirmed. If you were charged and still don't have access, contact support.",
    "checkAgain": "Check again",
    "failed": "That didn't go through, and you weren't charged. Please try again later.",
    "offersFailed": "Couldn't load the price. Check your connection.",
    "reload": "Try again",
    "unavailable": {
      "requires_app": "Chat is an add-on to Baby Plan. Start your Baby Plan membership first.",
      "not_configured": "Chat isn't available to buy just yet. Please check back soon.",
      "not_payer": "Chat isn't available for this account.",
      "disabled": "Chat isn't available for this account."
    },
    "inProgress": "Your purchase is already going through.",
    "disclaimer": "Baby Plan's chat is an AI assistant. It gives general information, not medical advice, and can be wrong. For urgent symptoms, call your pediatrician or 911."
  },
  "checkout": {
    "title": "Secure checkout",
    "lead": "Pay by card. Chat opens as soon as the payment is confirmed.",
    "loading": "Loading the payment form…",
    "loadFailed": "The payment form didn't load.",
    "retry": "Try again",
    "openExternal": "Continue to secure checkout",
    "back": "Back",
    "waiting": "Waiting for payment confirmation…"
  },
  "welcome": "Chat is ready. Ask your first question.",
  "work": {
    "label": "What the assistant is doing",
    "get_today": "Checking {{name}}'s day",
    "get_tracker_log": "Looking through {{name}}'s log",
    "reading": "Reading the course",
    "readingTitle": "Reading “{{title}}”",
    "other": "Checking the app",
    "writing": "Writing the answer"
  },
  "basis": {
    "label": "Based on:",
    "get_today": "{{name}}'s day",
    "get_tracker_log": "{{name}}'s log",
    "read_library": "The course"
  },
  "sources": {
    "label": "From Baby Plan",
    "lesson": "Lesson",
    "lessonMin_one": "Lesson · {{count}} min",
    "lessonMin_other": "Lesson · {{count}} min",
    "phase": "Development phase",
    "phaseMin_one": "Development phase · {{count}} min",
    "phaseMin_other": "Development phase · {{count}} min",
    "parent": "For you",
    "parentMin_one": "For you · {{count}} min",
    "parentMin_other": "For you · {{count}} min"
  },
  "actions": {
    "copy": "Copy the answer",
    "copied": "Copied",
    "good": "Helpful",
    "bad": "Not helpful",
    "thanks": "Thanks!",
    "sorry": "Thanks. We'll use this to make answers better."
  },
  "history": {
    "title": "Chats",
    "back": "Back to Chat",
    "count_one": "{{count}} chat",
    "count_other": "{{count}} chats",
    "searchLabel": "Search your chats",
    "searchPlaceholder": "Search chats",
    "clear": "Clear the search",
    "loading": "Loading your chats…",
    "groups": {
      "today": "Today",
      "yesterday": "Yesterday",
      "week": "Previous 7 days",
      "month": "Previous 30 days"
    },
    "found_one": "{{count}} chat mentions “{{q}}”",
    "found_other": "{{count}} chats mention “{{q}}”",
    "noMatch": "No chats mention “{{q}}”.",
    "emptyTitle": "No chats yet",
    "emptyBody": "Your questions and answers are kept here, so you can come back to them any time.",
    "askFirst": "Ask a question",
    "more": "Show older chats",
    "actions": "More for: {{title}}",
    "rename": "Rename",
    "renameTitle": "Rename chat",
    "renameLabel": "Chat name",
    "renameFailed": "Couldn't rename the chat. Please try again.",
    "save": "Save",
    "delete": "Delete",
    "cancel": "Cancel"
  }
}
